exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.infos-panel--large {\n  height: calc(100% - 48px);\n}\n.chat-panel--reduce {\n  height: 48px !important;\n}\n.posRelative {\n  position: relative;\n}\n.ContentInfosVisiteurPupitre {\n  height: 330px;\n}\n.morroringActif {\n  height: 100%;\n  bottom: 0;\n  right: 0;\n}\n.dialogueNewChat {\n  position: absolute;\n  top: 0px;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n}\n.ContentDialogNewChat {\n  position: absolute;\n  width: 320px;\n  height: 180px;\n  top: calc(50% - 80px);\n  left: calc(50% - 160px);\n}\n.mobileShowInfosVisiteur{\n  min-width: 100% !important;\n  left: 102%;\n  position: absolute;\n}\n.afficheInfos{\n  transition: left .5s ease-in-out;\n  left: 0px;\n}\n.cacheInfos{\n  transition: left .5s ease-in-out;\n  left: 102%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzViewChat.vue
// module id = dmtL
// module chunks = 1